import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertifyService } from '../../services/alertify.service';
import { DatePipe } from '@angular/common';
import { EditorChangeContent, EditorChangeSelection } from 'ngx-quill'
import { SystemService } from '../../services/system.service';
import { DocumentTypeService } from '../../services/documenttype.service';
import { TypeService } from '../../services/type.services';
import { Documenttype } from '../documenttype/documenttype';
import { TypeModel } from '../../model/type';
import { CategoryService } from '../../services/category.service';
import { SubCategoryService } from '../../services/subcategory.service';

@Component({
    selector: 'app-type-edit',
    templateUrl: './type-edit.component.html',
    styleUrls: ['./type-edit.component.scss'],
    providers: [DatePipe],
})
export class TypeEditComponent implements OnInit {
    typeForm: FormGroup;
    typelist: any[] = [];
    selectedtype: TypeModel | null = null;
    categories: any;
    subcategories: any;
    category: any;
    subcategoty: any;
    id: string;
    isLoading: boolean = false;

    constructor(private fb: FormBuilder, private typeservices: TypeService, private router: Router, private route: ActivatedRoute,
        private categoryService: CategoryService, private SubcategoryService: SubCategoryService, public service: SystemService) {
        this.id = this.route.snapshot.paramMap.get('id');
    }

    ngOnInit() {
        this.initializeForm();
        this.loadCategories();
        this.loadSubcategory();
        this.loadtypes();
    }

    initializeForm() {
        this.typeForm = this.fb.group({
            TypeId: [null, Validators.required],
            TypeTitle: ['', Validators.required],
            TypeDescription: ['', Validators.required],
            CategoryId: [null],
            SubcategoryId: [null],
            Location: ['', Validators.required],
            Phone: ['', Validators.required],
            Email: ['', [Validators.required, Validators.email]],
            Address: ['', Validators.required],
            Street: [''],
            City: [''],
            State: [''],
            Country: [''],
            Tags: [''],
            MetaKeys: [''],
            StartedYear: [null],
            isVerified: [false],
            Createdby: [''],
            CreatedDate: [''],
            Updatedby: [''],
            UpdatedDate: [''],
            Description: [''],
            Extra1: [''],
            Extra2: [''],
            Extra3: [''],
            Extra4: [''],
            Extra5: [''],
            Extra6: [''],
            Extra7: [''],
            Extra8: [''],
            Extra9: [''],
            Extra10: [''],
            isActive: [true],
            Status: [''],
            TypeofWork: [''],
            TypeofMode: [''],
            CompanySize: [''],
            Salary: [''],
            Currency: [''],
            isHome: [''],
            HeadFeatures: [''],
            MapLink: [''],
            Rating: [''],
            OpenClose: [''],
            Website: [''],
            Map: [''],
            ListingFeatures: [''],
            Price: [''],

        });
    }

    onMaterialGroupChange(event) {
        //console.log(event);
    }


    loadCategories() {
        this.categoryService.getAllCategories().then(categories => {
            this.categories = categories;

        });
    }

    loadSubcategory() {
        this.SubcategoryService.getAllSubCategories().then(subcategories => {
            this.subcategories = subcategories;

        });

    }

    loadtypes() {
        console.log(this.id);
        this.isLoading = true;
        this.typeservices.getTypeById(Number(this.id)).then(typelist => {
            typelist = this.convertKeysToCamelCase(typelist);
            this.typeForm.patchValue(typelist);
            const Categorybind = typelist.CategoryId.split(',').map(Number);
            const SubCategorybind = typelist.SubcategoryId.split(',').map(Number);
            console.log(Categorybind);
            console.log(SubCategorybind);
            this.category = Categorybind;
            this.subcategoty = SubCategorybind;
            console.log(JSON.stringify(this.typelist));
            this.isLoading = false;
        });
    }



    async onSubmit() {
        const type: TypeModel = this.typeForm.value;
        if (type.TypeId) {
            let obj = this.typeForm.getRawValue();
            const type: TypeModel = this.typeForm.value;
            console.log(obj);
            obj.Createdby = this.service.Account.UserID;
            obj.CategoryId = obj.CategoryId.map(String).join(',');
            obj.SubcategoryId = obj.SubcategoryId.map(String).join(',');
            const currentDate = new Date();
            const formattedDate = currentDate.toISOString().slice(0, 19).replace(' ', 'T');
            obj.UpdatedDate = formattedDate;
            obj.isActive = true;
            obj.Status = true;
            let res = this.typeservices.updateType(obj);
            if (res) {
                console.log(res);
                this.router.navigate(['/typelist']);
            }
        }
        // Reset the form
        this.typeForm.reset();
        this.selectedtype = null;
    }

    onEdit(type: TypeModel) {
        // Load the selected type into the form for editing
        console.log(JSON.stringify(JSON.stringify(type)));
        this.selectedtype = type;
        //**************************************PatchValue */
        type = this.convertKeysToCamelCase(type);
        this.typeForm.patchValue(type);
        const Categorybind = type.CategoryId.split(',').map(Number);
        const SubCategorybind = type.SubcategoryId.split(',').map(Number);
        console.log(Categorybind);
        console.log(SubCategorybind);
        this.category = Categorybind;
        this.subcategoty = SubCategorybind;
        console.log(JSON.stringify(this.typeForm.value));
    }

    onDelete(typeId: number) {
        let res = this.typeservices.deleteType(typeId);
        if (res) {
            this.loadtypes(); // Refresh the type list
        }
    }

    convertKeysToCamelCase(obj: any): any {
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }

        if (Array.isArray(obj)) {
            return obj.map((item) => this.convertKeysToCamelCase(item));
        }

        return Object.keys(obj).reduce((acc, key) => {
            const camelCaseKey = key.charAt(0).toUpperCase() + key.slice(1);
            acc[camelCaseKey] = this.convertKeysToCamelCase(obj[key]);
            return acc;
        }, {});
    }

    blured = false
    focused = false

    created(event) {
        // tslint:disable-next-line:no-console
        console.log('editor-created', event)
    }

    changedEditor(event: EditorChangeContent | EditorChangeSelection) {
        // tslint:disable-next-line:no-console
        console.log('editor-change', event)
    }

    focus($event) {
        // tslint:disable-next-line:no-console
        console.log('focus', $event)
        this.focused = true
        this.blured = false
    }

    blur($event) {
        // tslint:disable-next-line:no-console
        console.log('blur', $event)
        this.focused = false
        this.blured = true
    }
}


